import React, { useEffect, useState } from "react";


import message from 'antd/lib/message';
import Popconfirm from 'antd/lib/popconfirm';
import Spin from 'antd/lib/spin';
import { withRouter } from "react-router";
import AppService from './../../../../../service/app_service'

const PollPage = (props) => {

    const [loading, setLoading] = useState(false);
    const [transactions, setTransactions] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);

    const [identifier, setIdentifier] = useState(null);
    const [votingCode, setVotingCode] = useState(null);
    const [choice, setChoice] = useState(null);
    const [name, setName] = useState(null);
    const [showResult, setShowResult] = useState(false);
    const [totalVotes, setTotalVotes] = useState(0);


    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        if(params.has('showResult')) {
            console.log(params.get('showResult'))
            setShowResult(params.get('showResult'));
        }
        getTransactions(pageNumber);
        //eslint-disable-next-line

    }, []);

    const getTransactions = async (pageNumber) => {
        setLoading(true);
        AppService.getEvotingDetail(pageSize, pageNumber, props.match.params.uid, "yes").then(rec => {
            setLoading(false)
            if (rec.code != "200") {
                message.error(rec.message)
            } else {
                setTransactions(rec.data)
                if (rec && rec.list) {
                    //setTotalTransactionCount(rec.list.length);
                }
            }
        })

    }

    

    const voteEndpoint = async () => {
        let data = {
            "votingCode": votingCode,
            "choice": choice
        }
        setLoading(true);
        AppService.voteEndpoint(data, props.match.params.uid).then(rec => {
            setLoading(false)
            if (rec.code != "200") {
                message.error(rec.message)
            } else {
                message.success("Successfully Voted")
                setVotingCode('');
                getTransactions(pageNumber);
            }
        })
    }


    const handleChange = (e) => {
        if (e.target.name === 'votingCode') {
            setVotingCode(e.target.value);
        }if (e.target.name === 'opt1') {
            setChoice(e.target.value);
        }

    }

    const getPercentage = (option) => {
        let totalCount = 0;
        let count = 0;
        for (let i = 0; i < transactions.candidates.length; i++) {
            if (transactions.candidates[i].choice > 0) {
                if(transactions.candidates[i].choice == option) {
                    count++;
                }
                totalCount++;
            }
        }
        if(count === 0) {
            return 0;
        }
        let perc =  (count*100/totalCount).toFixed(0);
        setTotalVotes(totalCount);
        return perc;
    }

    const getTotalVotes = () => {
        let totalCount = 0;
        for (let i = 0; i < transactions.candidates.length; i++) {
            if (transactions.candidates[i].choice > 0) {
                totalCount++;
            }
        }
        return totalCount;
    }


    return (
        <div>
            
        <Spin spinning={loading}>
        {!showResult && <main className="overflow-hidden">
          <div className="container">
            <div className="wrapper popreveal">
              <div className="main-heading">
              {transactions && transactions.question}
              </div>
              <div className="pole-form">
                {/* form */}
                <form className="show-section" id="steps" method="post">
                  {/* step 1 */}
                  <fieldset id="step1" className="fields">
                  {transactions && transactions.options && transactions.options.length > 0 && transactions.options.map((item, i) => {
                        return <div className="radiofield delay-100ms revealfield" key={i} >
                            <input type="radio" name="opt1" defaultValue={i+1} onChange={handleChange} />
                            <label>{item.name}</label>
                        </div>
                    })}
                    {/* next btn */}
                    <div style={{marginTop: '20px'}}>
                        <input type="text"  name="votingCode" value={votingCode} className="form-control" placeholder="Voters code"  onChange={handleChange} />
                    </div>
                    <div className="next_prev">
                      <button type="button" className="next" id="sub" onClick={() => voteEndpoint()}>
                        <span>Vote Now</span>
                      </button>
                    </div>
                    
                  </fieldset>
                </form>
              </div>
              {/* footer  */}
              <footer>
                <div className="vote_count">
                  {<div className="total-votes">
                    Total Votes: {transactions && <span>{getTotalVotes()}</span>}
                  </div>}
                  <div id="countdown">
                  </div>
                </div>
                
              </footer>
            </div>
          </div>
        </main>}
        </Spin>
        {/* thankyou section */}
        
        {showResult && <main className="thankyoupage overflow-hidden" style={{display: 'block'}}>
          <div className="container">
            <div className="wrapper popreveal">
              <div className="main-heading">
                {transactions && transactions.question}
              </div>
              <div className="pole-form">
                <div className="thankyou">
                {transactions && transactions.options && transactions.options.length > 0 && transactions.options.map((item, i) => {
                        return <div className="result opt1" key={i} style={{width: getPercentage(i+1)+'%'}} >
                            <div className="prnct">{getPercentage(i+1)}%</div>
                            <div className="bar">
                                <label>{item.name}</label>
                                <div className="prnct-bar" style={{width: getPercentage(i+1)+'%'}}  />
                            </div>
                        </div>
                    })}
                  
                </div>
                <div className="next_prev">
                  <button id="goback" type="button" className="next" onClick={() => setShowResult(false)}>
                    <span>Undo?</span>
                  </button>
                </div>
              </div>
              <footer>
                <div className="vote_count">
                  {<div className="total-votes">
                    Total Votes: {transactions && <span>{getTotalVotes()}</span>}
                  </div>}
                </div>
              </footer>
            </div>
          </div>
        </main>}
      </div>
    );

}

export default withRouter(PollPage);
